import { useQuery } from '@tanstack/react-query';
import { api } from './client';
export function useAuditLog(filter) {
    const limit = filter.limit ?? 50;
    const page = filter.page ?? 1;
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    params.set('offset', String((page - 1) * limit));
    Object.entries(filter).forEach(([k, v]) => {
        if (k === 'page' || k === 'limit')
            return;
        if (Array.isArray(v))
            v.forEach((x) => params.append(k, String(x)));
        else if (v !== undefined && v !== '' && v !== null)
            params.set(k, String(v));
    });
    return useQuery({
        queryKey: ['audit', filter],
        queryFn: () => api(`/audit?${params}`),
    });
}
